'use client'

import { useProductListProvider } from 'product-list/context/ProductListProvider/useProductListProvider'
import { useVirtualPages } from 'product-list/hooks/useVirtualPages'
import { type ReactNode, useRef } from 'react'

import { useRestorePosition } from '../../hooks/useRestorePosition/useRestorePosition'
import { VIRTUAL_LIST_CLASS } from '../../hooks/useVirtualPages/useVirtualPages'

export function Pagination({
	children,
	total,
	perPage,
}: {
	readonly children?: (count: number) => ReactNode
	readonly total: number
	readonly perPage: number
}) {
	const ref = useRef(null)
	const { count } = useProductListProvider()

	useVirtualPages(ref, total, perPage)
	useRestorePosition()

	return (
		<div className={VIRTUAL_LIST_CLASS}>
			{children?.(count)}
			{/** biome-ignore lint/performance/noImgElement: FIX THIS */}
			<img ref={ref} alt='' />
		</div>
	)
}
